<template>
    <video class="video hero-video h-full w-full object-cover absolute left-0 top-0" muted loop autoplay playsinline data-keepplaying>
        <source src="../../../assets/videos/range-hero.mp4" type="video/mp4">
    </video>
</template>

<script>
    export default {
        name: "RangeBgVideo"
    }
</script>

<style scoped>

</style>